import * as _ from 'lodash'
import moment from 'moment'

import Pagination, {
  Page
} from '../../../components/pagination';
import auth from '../../../services/auth'
import Statements from '../../../services/statements';
import messageDialog from '../../../components/message-dialog.vue';
import * as F from '../../../filters/date';
import {
  beforeOneYear
} from '../../../validators/date';


const lastDaysOptions = [{
    value: '15',
    caption: 'Últimos 15 dias'
  },
  {
    value: '30',
    caption: 'Últimos 30 dias'
  },
  {
    value: 'custom',
    caption: 'Período personalizado'
  },
];
// {
  //     value: '60',
  //     caption: 'Últimos 60 dias'
  //   },
  //   {
    //       value: '90',
    //       caption: 'Últimos 90 dias'
    //     },

const pageSizeOptions = [{
    value: 20,
    caption: '20'
  },
  {
    value: 40,
    caption: '40'
  },
  {
    value: 60,
    caption: '60'
  },
  {
    value: 80,
    caption: '80'
  },
  {
    value: 100,
    caption: '100'
  },
];

export default {
  data() {
    return {
      // últimos N dias ou 'custom'
      lastDays: '15',
      lastDaysOptions,
      pageSizeOptions,
      // Se 'custom' a data inicial
      customStart: undefined,
      // Se 'custom' a data final
      customEnd: undefined,
      searchState: 'NEW',
      plate: undefined,
      showPlate: false,
      vehiclesBalance: undefined,
      // vehiclesBalancePlates: undefined,
      page: new Page(),
      arrayPlate: new Array()
    }
  },
  computed: {
    contractId() {
      return this.$route.params.contractId;
    },
    currentUser() {
      return auth.currentUser;
    },
    /** Calcula a data inicial do relatório **/
    periodStart() {
      let days = this.lastDays;
      let d = (days == 'custom') ?
        moment(this.customStart) :
        moment().subtract(parseInt(days), 'd');

      return d.startOf('day').valueOf();
    },

    /** Calcula a data final do relatório **/
    periodEnd() {
      let days = this.lastDays;
      let d = (days == 'custom') ?
        moment(this.customEnd) :
        moment();

      return d.endOf('day').valueOf();
    },
  },
  mounted:
    function() {
      this.doFilter();
    },

    // $('#selectAll').on('click', function () {
    // });

  methods: {
    setCurrentPage(p) {
      this.page = this.page.page(p);
      $('.check-item').each(function () {this.checked = false;});
      // this.arrayPlate = new Array();
      this.doFilter();
    },
    setPageSize(size) {
      this.page = this.page.size(size);
      this.doFilter();
    },
    checkAll() {
      let checkAll = document.getElementById('selectAll');
      if (checkAll.checked) {
        $('.check-item').each(function () {this.checked = true;});
        Statements.getSaldoVeiculosFull({'moveMaisId': auth.currentUser.moveMaisId}).then(data => {
          // this.vehiclesBalancePlates = data.itens;
          data.itens.forEach(o => {
            this.arrayPlate.push(o.plate);
          });
        });
      } else {
        $('.check-item').each(function () {this.checked = false;});
        this.arrayPlate = new Array();
      }
    },
    check(id) {
      let value = $('#'+id).parents('tr').find('.td-plate').text();

      if(this.arrayPlate.includes(value)) {
        document.getElementById(id).checked = false;
        this.arrayPlate.splice(this.arrayPlate.indexOf(value), 1);
      } else {
        this.arrayPlate.push(value);
      }
      
    },
    validate() {
      let error = this.errors;
      //this.searchState = 'NEW';
      let filter = {
        moveMaisId: auth.currentUser.moveMaisId,
        // startDate: this.periodStart,
        // endDate: this.periodEnd,
        plate: this.plate,
        page: this.page.build()
      };

      if(filter.plate == "") {
        delete filter.plate;
      }

      if (this.lastDays == 'custom' && (!this.customStart || !this.customEnd || (this.customStart > this.customEnd))) {
        this.searchState = 'ERROSEARCH';
        this.messageError = (this.customStart && this.customEnd) ? 'Impossível filtrar! O período inicial é mais novo que o período final.' : 'Existem campos não preenchidos!'
        return false;
      }

      if (this.lastDays == 'custom' && beforeOneYear.validate(moment(this.customStart).format("L"))) {
        this.searchState = 'ERROSEARCH';
        this.messageError = 'Período indisponível! Para consultas de período anteriores a um ano, favor entrar em contato com a nossa Central de Relacionamento.';
        return false;
      }

      if ( this.lastDays == 'custom' && this.customStart && this.customEnd  && ( (this.customEnd - this.customStart  ) > (2678400000) ) ) {
        //2678400000 = 31 dias
        this.searchState = 'ERROSEARCH';
        this.messageError = 'Período máximo permitido, 31 dias.';
         return false;
      }

      return filter;
    },
    doFilter(clearCache) {
      let filter = this.validate();
      $('.check-item').each(function () {this.checked = false;});

      if (clearCache) {
        this.listTransactionRefund = [];
        filter.page = 1;
        this.page = filter.page = this.page.page(1);
      }

      if (filter) {
        let promise = Statements.getSaldoVeiculosFull(filter).then(data => {
            this.vehiclesBalance = data.itens;
            if (data.total) {
              this.searchState = 'FOUND';
              this.page = this.page.itemCount(data.total);
              this.$nextTick(() => {
                $('[data-toggle="tooltip"]').tooltip();
                $('html, body').stop().animate({
                  scrollTop: $("#vehicleFullTable").offset().top - 110
                }, 1000);
              });
            } else {
              this.searchState = 'NOTFOUND';
            }
          })
          .catch(err => {
            this.searchState = 'NOTFOUND';
          });
        this.$store.dispatch('loading', promise);
      }
    },
    exportarExtratoConsolidado() {
      
      if (this.arrayPlate.length > 0) {
        let filter = {
          endDate: F.date(this.periodEnd, 'YYYY-MM-DD'),
          startDate: F.date(this.periodStart, 'YYYY-MM-DD'),
          plate: this.arrayPlate,
          moveMaisId: auth.currentUser.moveMaisId
        }
        let promise = Statements.exportarExtratoConsolidadoNew(filter).then(data => {
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'ExtratoConsolidado_'+filter.moveMaisId+'.xlsx');
          document.body.appendChild(link);
          link.target="_blank"
          link.click();
          link.parentNode.removeChild(link);
        }).catch(err => {
          return messageDialog.show({
            title: 'Falha ao emitir o relatório',
            message: err.data.status.message,
            type: 'OK'
          });
        });
        this.$store.dispatch('loading', promise);
      } else {
        return messageDialog.show({
          title: 'Falha ao emitir o relatório',
          message: 'Selecione ao menos uma placa para extrair o relatório.',
          type: 'OK'
        });
      }
    },
    removePlate(plate) {
      // $('#'+id).parents('tr').find('.td-plate').text();

      if(this.arrayPlate.includes(plate)) {
        this.arrayPlate.splice(this.arrayPlate.indexOf(plate), 1);
        $('#vehicleFullTable').find("."+plate).parents('tr').find('.check-item').prop('checked', false);
        
      }
    }
  },
  filters: {
    plate(value) {
      if (!value) return value;
      return value.substring(0, 3) + " - " + value.substring(3);
    },
    local(value) {
      let p = /.*km[\s0-9]*/.exec(value);
      if (p && p.length > 0)
        return p[0];
      else
        return value;
    },
    barWrap(value) {
      return value.split("/").join(' / ');
    }
  },
  components: {
    Pagination
  },
}



// WEBPACK FOOTER //
// ./src/pages/account/toll-ticket/statement-consolidated.js